// @ts-ignore
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  UxIconEnum,
  UxPriorityEnum,
  UxSizeEnum,
  UxShadesEnum,
  UxAction,
  UxStyleEnum,
  classMap
} from "@imaginelearning/mps-ux-component-library";

import "./edge-back-button.scss";
import useGradeRange from "hooks/usegraderange";

interface IProps {
  onBackClick?: () => void;
  iconName?: UxIconEnum;
  iconSize?: UxSizeEnum;
  classNames?: string;
}

function EdgeBackButton(props: IProps) {
  const { onBackClick, iconName, iconSize, classNames } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const title = t("Back");
  const { isKto5 } = useGradeRange();

  return (
    <UxAction
      style={UxStyleEnum.CIRCLE}
      enabled={true}
      callback={() => (onBackClick ? onBackClick() : navigate(-1))}
      priority={isKto5 ? UxPriorityEnum.PRIMARY : UxShadesEnum.LIGHT}
      className={classMap(`edge-back-button p-3 animation transform-ease z-index-1 ${classNames || "position-fixed"}`)}
      icon={{
        icon: iconName || UxIconEnum.ARROW_LEFT,
        size: iconSize || UxSizeEnum.LARGE,
        title,
        squared: true,
        className: "d-block"
      }}
      role="button"
      ariaLabel={t("Back To Dashboard")}
    />  
  );
}

export default EdgeBackButton;
